document.addEventListener('DOMContentLoaded', () => {
  const dialog = document.querySelector('.purchase-order-preview');
  if (!dialog || typeof dialog.showModal !== 'function') return;

  const frame = dialog.querySelector('iframe');
  let trigger;
  document.querySelectorAll('[data-po-preview]').forEach((link) => {
    link.setAttribute('aria-haspopup', 'dialog');
    link.addEventListener('click', (event) => {
      if (event.ctrlKey || event.metaKey || event.shiftKey || event.altKey)
        return;
      event.preventDefault();
      trigger = link;
      dialog.querySelector('.purchase-order-preview__filename').textContent =
        link.dataset.filename;
      dialog.querySelector('.purchase-order-preview__open').href = link.href;
      dialog.querySelector('.purchase-order-preview__download').href = link
        .closest('td')
        .querySelector('.purchase-order-download').href;
      frame.src = link.href;
      dialog.showModal();
      document.documentElement.classList.add('purchase-order-preview-open');
    });
  });
  dialog
    .querySelector('.purchase-order-preview__close')
    .addEventListener('click', () => dialog.close());
  dialog.addEventListener('close', () => {
    frame.removeAttribute('src');
    document.documentElement.classList.remove('purchase-order-preview-open');
    if (trigger) trigger.focus();
  });
});
